import { render, staticRenderFns } from "./PatientSessionView.vue?vue&type=template&id=51f52b12&scoped=true"
import script from "./PatientSessionView.vue?vue&type=script&lang=js"
export * from "./PatientSessionView.vue?vue&type=script&lang=js"
import style0 from "./PatientSessionView.vue?vue&type=style&index=0&id=51f52b12&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51f52b12",
  null
  
)

export default component.exports